import { render, staticRenderFns } from "./PluginStep.vue?vue&type=template&id=20b8425e"
import script from "./PluginStep.vue?vue&type=script&lang=js"
export * from "./PluginStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports